import { Status, withProps } from '@mna/react'


export default withProps(props => {

  // TODO: Handle Azure login responses
  // Move to its own route when URL is known

  // Parse query parameters on server and client

  const { location } = props

  console.log('404', location)

  return props

})(() =>
  <div className="article-width">
    <Status code={404} />
    <h1>Page not found</h1>
  </div>
)
